export default "__VITE_ASSET__rHBFzhKE__"